import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../types/rootState'
import { ContactHomebot } from '../../types/contactHomebot'

// STEPS
export const DISCLAIMER = 'DISCLAIMER'
export const EMAIL = 'EMAIL'
export const COMMENTS = 'COMMENTS'
export const CONTACT_CONFIRMATION = 'CONTACT_CONFIRMATION'

export const STEPS = [DISCLAIMER, EMAIL, COMMENTS, CONTACT_CONFIRMATION]
export const STEPS_CONST = [
  DISCLAIMER,
  EMAIL,
  COMMENTS,
  CONTACT_CONFIRMATION,
] as const
export type ContactHomebotStepType = typeof STEPS_CONST[number]

const initialState: ContactHomebot = {
  step: STEPS_CONST[0],
  showModal: false,
  acceptedDisclaimer: false,
  email: '',
  comments: '',
}

const contactHomebotSlice = createSlice({
  name: 'ContactHomebot',
  initialState,
  reducers: {
    setContactHomebotStep: (
      state,
      action: PayloadAction<ContactHomebotStepType>
    ) => {
      state.step = action.payload
    },
    setContactHomebotShowModal: (state, action: PayloadAction<boolean>) => {
      state.showModal = action.payload
    },
    setContactHomebotAcceptedDisclaimer: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.acceptedDisclaimer = action.payload
    },
    setContactHomebotEmail: (state, action: PayloadAction<string>) => {
      state.email = action.payload
    },
    setContactHomebotComments: (state, action: PayloadAction<string>) => {
      state.comments = action.payload
    },
    setContactHomebotStepAdvanceOneStep: state => {
      state.step = STEPS_CONST[STEPS.indexOf(state.step) + 1]
    },
    setContactHomebotDataToInitialState: () => initialState,
  },
})

// Selectors
export const selectContactHomebotStep = (state: RootState) =>
  state.contactHomebot.step
export const selectContactHomebotShowModal = (state: RootState) =>
  state.contactHomebot.showModal
export const selectContactHomebotAcceptDisclaimer = (state: RootState) =>
  state.contactHomebot.acceptedDisclaimer
export const selectContactHomebotEmail = (state: RootState) =>
  state.contactHomebot.email
export const selectContactHomebotComments = (state: RootState) =>
  state.contactHomebot.comments

export const {
  setContactHomebotStep,
  setContactHomebotShowModal,
  setContactHomebotAcceptedDisclaimer,
  setContactHomebotEmail,
  setContactHomebotComments,
  setContactHomebotStepAdvanceOneStep,
  setContactHomebotDataToInitialState,
} = contactHomebotSlice.actions

export default contactHomebotSlice.reducer
